import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';

import { CoreWidgetsModule } from '../../../widgets/core.widgets.module';
import { CoreServicesModule } from '../../core.services.module';

import { SiteHelpService } from './site-help.service';
import { SiteHelpComponent } from './site-help.component';
import { SiteHelpPageComponent } from './site-help-page/site-help-page.component';
import { SiteHelpSearchComponent } from './site-help-search/site-help-search.component';
import { SITE_HELP_STATES } from './site-help.routes.config';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        CoreWidgetsModule,
        CoreServicesModule,
        UIRouterModule.forChild({
            states: SITE_HELP_STATES
        })
    ],
    providers: [
        SiteHelpService
    ],
    declarations: [
        SiteHelpComponent,
        SiteHelpPageComponent,
        SiteHelpSearchComponent
    ]
})
export class SiteHelpModule { }
